// extracted by mini-css-extract-plugin
export var filterIncDec = "_d1-0";
export var leftBorder = "_d1-1";
export var rightBorder = "_d1-2";
export var stringInput = "_d1-3";